import React, { StrictMode } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Header from './Header/Header';
import Switcher from './Switcher';
import Footer from './Footer/Footer';
import s from '../index.scss';

const App = ({ location }) => (
	<StrictMode>
		<Header />
		<div className={[s.main, (location?.type === 'START' ? s.main__start : null), (location?.type === 'SEARCH' ? s.main__search : null)].join(' ')}>
			<Switcher />
		</div>
		<Footer />
	</StrictMode>
);

const mapState = ({ location }) => ({ location });

export default hot(module)(connect(mapState)(App));
